import { useState } from 'react'

import {
  Box,
  Button,
  Checkbox,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { useUpdateUser } from '@/react-query/user'

export const MicPrestartModal = ({
  isOpen,
  onClose,
  startRecording,
}: {
  isOpen: boolean
  onClose: () => void
  startRecording: () => void
}) => {
  const updateUser = useUpdateUser()

  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false)

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'xl'}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Record via microphone</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <p>🎙️&nbsp;&nbsp;Record via your laptop&apos;s microphone.</p>
          <br />
          <p>🔊&nbsp;&nbsp;Please use speakers, not headphones.</p>
          <br />
          <p>🙇&nbsp;&nbsp;Please always ask for consent before recording.</p>
          <Box>
            <Checkbox
              onChange={(e) => setIsCheckboxChecked(e.target.checked)}
              mt={12}
            >
              Don&apos;t show this again
            </Checkbox>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={async () => {
              if (isCheckboxChecked) {
                await updateUser.mutateAsync({
                  user: {
                    showLiveRecordingPopup: false,
                  },
                })
              }
              startRecording()
              onClose()
            }}
            rounded={'1.25rem'}
            variant={'brand-solid'}
          >
            Start recording
          </Button>
          <Button variant={'brand-solid-white'} onClick={onClose}>
            Not now
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
